import React from "react";
import styled from "styled-components";
import { v4 as uuidv4 } from "uuid";
import Link from "../styles/shared/Links/Link";
import LinkWrap from "../styles/shared/Links/LinkWrap";
import { breakpoints, maxWidth } from "../styles/variables/breakpoints";

const LinkPhone = styled(Link)`
  background-image: url("/modules/custom/custom_react_maps/img/phone-blue.svg");
  ${maxWidth(breakpoints.md)} {
    font-size: 12px;
    line-height: 14px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 9px;
    line-height: 11px;
    background-size: 0;
    background-image: none;
  }
`;

const LinkEmail = styled(Link)`
  background-image: url("/modules/custom/custom_react_maps/img/email-blue.svg");
  background-size: 1.4rem;
  ${maxWidth(breakpoints.md)} {
    font-size: 12px;
    line-height: 14px;
  }
  ${maxWidth(breakpoints.sm)} {
    font-size: 9px;
    line-height: 11px;
    background-size: 0;
    background-image: none;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
`;

export const createPhoneNumbersList = (phoneNumbers: string) => {
  if (!phoneNumbers) {
    return;
  }
  let numbersArray = phoneNumbers.split(",");
  const phoneNumbersList = numbersArray.map(phoneNumber => (
    <LinkWrap key={uuidv4()}>
      <LinkPhone href={`tel:${phoneNumber.replace(/ /g, "")}`}>
        {phoneNumber}
      </LinkPhone>
    </LinkWrap>
  ));

  return phoneNumbersList;
};

export const createEmailsList = (emails: string) => {
  if (!emails) {
    return;
  }
  let emailsArray = emails.split(",");
  const emailsList = emailsArray.map(email => (
    <LinkWrap key={uuidv4()}>
      <LinkEmail href={`mailto:${email}`}>{email}</LinkEmail>
    </LinkWrap>
  ));

  return emailsList;
};
